export enum UserType {
    NotAuthorized = 0,
    NBRB = 1,
    Organisation = 2,
    Guest = 3,
}


// WEBPACK FOOTER //
// ./common/enums/userType.ts